var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Stack, RadioGroup as ChakraRadioGroup, } from "@chakra-ui/react";
import { ColorScheme, Spacing } from "../../core/constants";
import Radio from "./Radio";
import FormControl from "../FormControl";
function RadioGroup(props) {
    var _a;
    const { className, colorScheme, variantColor = ColorScheme.primary, spacing = Spacing[2], options, children, label, name, error, helper, size, isInline } = props, rest = __rest(props, ["className", "colorScheme", "variantColor", "spacing", "options", "children", "label", "name", "error", "helper", "size", "isInline"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(ChakraRadioGroup, Object.assign({}, rest, { size: size, name: name, colorScheme: scheme, className: className }),
            React.createElement(Stack, { spacing: spacing, direction: isInline ? "row" : "column" }, (_a = options === null || options === void 0 ? void 0 : options.map(({ label: radioLabel, value, isDisabled }) => (React.createElement(Radio, { value: value, isDisabled: isDisabled, key: radioLabel, size: size, colorScheme: scheme }, radioLabel)))) !== null && _a !== void 0 ? _a : children))));
}
RadioGroup.displayName = "RadioGroup";
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map